import { render, staticRenderFns } from "./Beneficiary.vue?vue&type=template&id=2efebd8a&scoped=true&"
import script from "./Beneficiary.vue?vue&type=script&lang=js&"
export * from "./Beneficiary.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/pages/requests/beneficiary.scss?vue&type=style&index=0&id=2efebd8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efebd8a",
  null
  
)

export default component.exports